/**
 * Utilitários de telefone (pt-BR) compartilhados.
 *
 * Fonte única de verdade para formatação/normalização de telefone no frontend.
 * Antes duplicado em CustomerPicker.js; extraído aqui para reuso e testes.
 */

import { looksLikeBsuid } from './identity';

/**
 * Extrai apenas os dígitos de uma string (tolerante a null/undefined/number).
 * @param {string|number|null|undefined} value
 * @returns {string}
 */
export function digitsOnly(value) {
  return String(value ?? "").replace(/\D/g, "");
}

/**
 * Formata dígitos para o padrão brasileiro `(XX) XXXXX-XXXX`.
 * Tolerante a entradas parciais, null/undefined e strings já formatadas.
 * Retorna "" quando não há dígitos.
 * @param {string|number|null|undefined} value
 * @returns {string}
 */
export function formatPhoneBR(value) {
  if (looksLikeBsuid(value)) return "";
  const digits = digitsOnly(value).slice(0, 11);
  if (!digits) return "";
  if (digits.length <= 2) return digits;
  if (digits.length <= 7) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
}
